import { averagePerDay } from '../calculators/averagePerDay'
import { countConversationsAssigned } from '../queries/countConversationsAssigned'

export const conversationsAssignedPerDayGauge = {
  calculate: averagePerDay,
  description: 'Average number of incoming conversations per day.',
  queries: [countConversationsAssigned],
  title: 'Assigments Per Day',
}
